module.exports = __webpack_public_path__ + "static/creator-tokens-foreground-c399d88ffd60ba283875adf8f425d182.webp";